import React, {Fragment, useContext, useState} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ViewerContext } from "../../context/ViewerContext";
import wmsMaps from "../../configs/wmsMapList";
import {MdArrowForwardIos} from "react-icons/md";
import { TbPlayerRecord  } from "react-icons/tb";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

export default function BaseMap() {
    const { showBaseMap, setShowBaseMap,setLegalShort, addWMSLayer} = useContext(ViewerContext);
    const [ maps, setMaps ] = useState(wmsMaps());

    const filterListBySearch = (search) => {

        const newMap = [...maps];
        const searchValue = search?.target?.value?.toLowerCase();

        for (var c = 0; c < maps?.length; c++) {

            var categoryHidden = true;
            for (var m = 0; m < maps?.[c]?.urls?.length; m++ ) {

                var nameMatches = maps?.[c]?.urls?.[m]?.["label"]?.toLowerCase()?.includes(searchValue);

                if(nameMatches) {
                    newMap[c].urls[m].hidden = false;
                    categoryHidden = false;
                } else {
                    newMap[c].urls[m].hidden = true;
                }
            }

            if(categoryHidden) {
                newMap[c].hidden = true;
            } else {
                newMap[c].hidden = false;
            }
        }

        setMaps(newMap);
    };


    return (
        <Transition.Root show={showBaseMap} as={Fragment}>
            <Dialog className="relative z-10" onClose={setShowBaseMap}>
                <div className="fixed inset-0" />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 z-50 right-0 flex max-w-full pl-10 sm:pl-16  mt-[59px] lg:mt-[0px]  sideOver ">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white px-2 py-14 shadow-xl">
                                        <div className="px-4">
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title className="text-xl px-2 mb-6 font-semibold leading-6 text-gray-900">
                                                    Kartendarstellung
                                                </Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md bg-white text-gray-900 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                                        onClick={() => setShowBaseMap(false)}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-9 w-9" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="relative flex-1 px-4 sm:px-6">

                                            <input name="search" onChange={(e) => {filterListBySearch(e)}} placeholder={"Suche ..."} className={"border w-full mb-3 rounded px-4 py-2"}/>

                                            { maps?.map((mapId) =>(
                                                <div key={mapId.label}>
                                                    {(mapId?.hidden === false) ? (
                                                        <Accordion key={mapId}>
                                                            <AccordionSummary
                                                                expandIcon={<MdArrowForwardIos className={"text-lg p-0 m-0 truncate font-bold text-gray-900"} />}
                                                                aria-controls="panel2-content"
                                                                id="sideOverAccordingTitle"
                                                            >
                                                                <div className={"flex overflow-hidden justify-between truncate w-full mr-2"}>
                                                                    <b className={"flex w-full truncate"}><TbPlayerRecord    className={" h-5 w-5 mr-2"} /><span style={{maxWidth: "300px"}} className={"truncate max-w-full block"}> { mapId?.label }</span></b>
                                                                </div>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <ul className={"p-0 m-0"}>
                                                                    { mapId?.urls?.map((id) => (

                                                                        <li style={(id?.hidden === true)? {display:"none"}:{display:"block"}}  onClick={() => {addWMSLayer({ url:id?.url, size:id?.size }); setLegalShort(id?.legalShort); setShowBaseMap(false); }} className={"pb-2 px-2 text-sm items-center flex hover:text-gray-600 border-gray-500 cursor-pointer"} key={id?.label}>
                                                                            {id?.label}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    ) : ("")}
                                                </div>
                                            )) }

                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
